import { ICommon } from './common';
import { ITenant } from './tenants';

export interface IPermission extends Partial<ICommon> {
	name: string;
	description: string;
	systemDefault?: boolean;
}

export interface IRole extends Partial<ICommon> {
	name: string;
	description: string;
	default: boolean;
	permissions: IPermission[];
	systemDefault?: boolean;
}

export interface IRolesTenantsMapping {
	roles: IRole[];
	tenants: ITenant[];
}
export interface IRolesTenantsMappings {
	mappings?: IRolesTenantsMapping[];
}

export enum AuthorizationPageTabs {
	roles = 'roles',
	permissions = 'permissions'
}
